import { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchData } from "../../redux/data/dataActions";
import { Modal, Card, Container, Row, Col, Button } from "react-bootstrap";
import Particle from "../Particle";
import { BiLinkExternal } from "react-icons/bi";
import Footer from "../Footer";

function NFTGallery(props) {
  const dispatch = useDispatch();
  const blockchain = useSelector((state) => state.blockchain);
  const data = useSelector((state) => state.data);
  const [NFTS, setNFTS] = useState([]);
  const [claimingRewards, setClaimingRewards] = useState(false);
  const [feedback, setFeedback] = useState("");
  const ipfsBaseUrl = "https://ipfs.io/ipfs/";
  const [loadingNFTS, setLoadingNFTS] = useState(false);
  const [modalShow, setModalShow] = useState(false);
  const [buildModal, setBuildModal] = useState(false);
  const [modalData, setModalData] = useState();

  // fetch(ipfsBaseUrl + (nft.uri).substring(7))
  const fetchMetatDataForNFTS = () => {
    if(!loadingNFTS){
      setLoadingNFTS(true);
      console.log("Here Here");
      setNFTS([]);
      data.allTokens.forEach((nft) => {
        let uri = "";
        if(nft.uri.startsWith("ipfs")){
        uri = ipfsBaseUrl + (nft.uri).substring(7);
        }else{
          uri = nft.uri;
        }
        if(uri.length != ipfsBaseUrl.length){ 
          fetch( uri)
            .then((response) => response.json())
            .then((metaData) => {
              setNFTS((initialState) => [
                ...initialState,
                { id: nft.id, metaData: metaData, refBalance: nft.refBalance },
              ]);
            })
            .catch((err) => {
              console.log(err);
              setLoadingNFTS(false);
            });
        }
      });
      setLoadingNFTS(false);
    }
  };

  const claimRoyalties = () => {
    console.log("Claiming Royalties");
    setFeedback("Claiming your Bull Royalties...");
    setClaimingRewards(true);
    blockchain.mbsaRoyaltyReceiver.methods
      .claimReflection()
      .send({
        gasLimit: "300000",
        to: "0xd859e80aDCDc306F683fdF3202aCeF54C5dcFdEc",
        from: blockchain.account,
        value: data.royalties,
      })
      .once("error", (err) => {
        console.log(err);
        setFeedback("Sorry, something went wrong please try again later.");
        setClaimingRewards(false);
      })
      .then((receipt) => {
        setFeedback(
          "WOW, you got some rewards."
        );
        blockchain.mbsaBullNFT.methods
          .claimReflectionRewards()
          .send({
            gasLimit: "300000",
            to: "0xd859e80aDCDc306F683fdF3202aCeF54C5dcFdEc",
            from: blockchain.account,
          })
          .once("error", (err) => {
            console.log(err);
            setFeedback("Sorry, something went wrong please try again later.");
            setClaimingRewards(false);
          })
          .then((receipt) => {
            setFeedback(
              "WOW, you got some rewards."
            );
          });
        setClaimingRewards(false);
        dispatch(fetchData(blockchain.account));
      });
      dispatch(fetchData(blockchain.account));
  };

  useEffect(() => {
    if (blockchain.account !== "" && blockchain.mbsaBullNFT !== null) {
      dispatch(fetchData(blockchain.account));
      setLoadingNFTS(false);
    }
  }, [blockchain.mbsaBullNFT, dispatch]);

  useEffect(() => {
      fetchMetatDataForNFTS();
  }, [data.allTokens, dispatch]);

function MydModalWithGrid(props) {
  if (modalData != null && buildModal){
    let annft = modalData;
    let imgUrl = ipfsBaseUrl + (annft.metaData.image).substr(7);
    return (
      <Row  className="modal">
      <Modal {...props} 
        size="xl"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        backdrop={false}
        >
        <Modal.Header closeButton className="modal-header">
          <Modal.Title id="contained-modal-title-vcenter">
            MBSA Bull {annft.metaData.name}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="modal-body">
          <Container>
            <Card className="sinfo-attr-card-view" key={annft.id}>
              <Row style={{ justifyContent: 'center', paddingBottom: '10px' }}>
              <Col md={6}>
                <Card.Text>&nbsp;&nbsp;&nbsp;Name: {annft.metaData.name}</Card.Text>
                <Card.Text>&nbsp;&nbsp;&nbsp;ReflectionBalance: {annft.refBalance / 10**18}</Card.Text>
                <Card.Text>&nbsp;&nbsp;&nbsp;Description: {annft.metaData.description}</Card.Text>
              </Col>
              <Col md={6}  style={{ justifyContent: 'right', paddingTop: '5px'  }}>
                {/* <Card.Img variant="top" src={imgUrl} alt="att-card-img" /> */}
                <img
                  src={imgUrl}
                  alt="NFT"
                  className="att-img"
                />
              </Col>
              </Row>              
              <Card.Body>
                <Card.Text style={{ textAlign: "justify" }}>
                  {/* {props.annft.metaData.description} */}
                </Card.Text>
                <Row style={{ justifyContent: 'center', paddingBottom: '10px' }}>
                {
                  annft.metaData.attributes.map((att, index) => {
                    return(
                      <Col md={3}>
                        <Card  className="sinfo-attr-view" key={annft.id}>
                          <Card.Header>{att.trait_type}</Card.Header>
                          <Card.Body>
                            <Card.Title class="white" style={{ textAlign: "justify", paddingBottom: "20px"}}>
                              <h5>{att.value.replaceAll('_', ' ')}</h5>
                            </Card.Title>
                          </Card.Body>
                        </Card>
                      </Col>
                    )
                  })
                }
                </Row>
              </Card.Body>
            </Card>
          </Container>
        </Modal.Body>
        <Modal.Footer className="modal-footer">
          <Button onClick={props.onHide}>Close</Button>
        </Modal.Footer>
      </Modal>
      </Row>
    );
  }else{
    return (
      <Modal aria-labelledby="contained-modal-title-vcenter">
      </Modal>
    );
  }
}

  return (
    <section>
    <Container >
      {/* <Particle /> */}
      <Row style={{ justifyContent: "center", paddingTop: "40px" }}>
      </Row> 
      <Container className="home-section" id="Minter">
        <h1 className="nftgallery-heading">
          <strong className="purple">My Bulls </strong>
        </h1><br/>
        <Row style={{ justifyContent: "right", paddingTop: "10px", paddingBottom: "10px" }}>
          <div id="my-group" class="input-group">
              <label class="white">{data.royalties / 10**18} AVAX</label>
              <div class="input-group-append">
                  <Button class="btn btn-outline-secondary" type="button" onClick={(e) => {
                    e.preventDefault();
                    claimRoyalties();
                    }}
                  >
                  Claim</Button>
              </div>
          </div>
        </Row>
        <Row style={{ justifyContent: "center", paddingBottom: "25px", paddingTop: "25px", paddingLeft: "25px", paddingRight: "25px" }}>
          {data.loading ? (
            <>
              <br/>
              <h5 class="green" style={{ textAlign: "center" }}>
                loading...
              </h5>
            </>
          ) : (
          NFTS.map((nft, index) => {
            let imgUrl = ipfsBaseUrl + (nft.metaData.image).substr(7);
            let keyIndex = index;
            console.log("index = " + index);
            return(
              // <Col md={4} className="nft-card">
              <Col md={3} style={{ justifyContent: "space-around", paddingBottom: "5px", paddingTop: "5px", paddingLeft: "5px", paddingRight: "5px" }}>
                <Col style={{ width:"100%", justifyContent: "space-around", paddingBottom: "5px", paddingTop: "5px", paddingLeft: "5px", paddingRight: "5px" }}>
                <Card key={index} className="sinfo-card-view">
                  <Card.Text>Name :{nft.metaData.name}</Card.Text>
                  <Card.Text>ReflectionBalance :{nft.refBalance / 10**18}</Card.Text>
                  <Card.Text>Description :{nft.metaData.description}</Card.Text>
                  <Card.Img variant="top" src={imgUrl} alt="card-img" />
                  <Card.Body >
                    <Card.Text style={{ textAlign: "justify" }}>
                      {nft.metaData.description}
                    </Card.Text>
                    <Button variant="primary" href={imgUrl} target="_blank">
                      {/* <BiLinkExternal /> &nbsp; */}
                      {"View NFT"}
                    </Button>
                        <Button variant="primary" onClick={() => {
                      setModalData(NFTS[keyIndex]);
                      setBuildModal(true);
                      setModalShow(true);                      
                      }}>
                      {"Attributes"}
                    </Button>
                    <MydModalWithGrid className="modalContainer" show={modalShow} ikey={keyIndex} onHide={() => {
                      setModalShow(false);
                      setBuildModal(false);
                      }} />
                  </Card.Body>
                </Card>
                </Col>
              </Col>
            );
          })
          )}
        </Row>
        <Row style={{ justifyContent: "center", paddingTop: "50px", paddingBottom: "10px" }}>
          <p id="status">{feedback}</p>
        </Row>
        <Row style={{ justifyContent: "center", paddingTop: "50px", paddingBottom: "50px" }}></Row>
          <Footer />
      </Container>
     </Container>
    </section>
  );
}

export default NFTGallery;
